import React, { useEffect, useState } from "react";

import BarChart from "../../components/DashboardComponent/BarChart";
import PieCharts from "../../components/DashboardComponent/PieCharts";
import TransactionCount from "../../components/DashboardComponent/TransactionCount";
// import Layout from "../../components/Layout/Layout";
import Layout from '../../../../src/components/Layout'
import Switch from "react-switch";
import {
  getTerminalMetricsRequest,
  getTerminalRequestStatsRequest,
  getProcessorInventoryRequest,
  getRevenueMetricsRequest,
  getMerchantsRequest,
} from "../../services/requests/dashboard.request.js";

const Dashboard = () => {
  const [dashboardStatistics, setDashboardStatistics] = useState(null);
  const [membershipMetrics, setMembershipMetrics] = useState(null);
  useEffect(() => {
    const reloadCount = JSON.parse(localStorage.getItem("reloadCount"));
    if (reloadCount === 0) {
      localStorage.setItem("reloadCount", reloadCount + 1);
      window.location.reload();
    }
  }, []);

  useEffect(() => {
    const getRevenueMetrics = async () => {
      const [
        terminalStatsRes,
        terminalRequestStatsRes,
        processorInventoryRes,
        revenueRes,
        merchantsRes,
      ] = await Promise.all([
        getTerminalMetricsRequest(),
        getTerminalRequestStatsRequest(),
        getProcessorInventoryRequest(0, 10),
        getRevenueMetricsRequest(),
        getMerchantsRequest(0, 20),
      ]);

      const terminalStats = terminalStatsRes?.data || {};
      const terminalRequestStats = terminalRequestStatsRes?.data || {};
      const processorInventory = processorInventoryRes?.data?.summary || {};
      const revenue = revenueRes?.respBody || {};
      const merchants = merchantsRes?.data || {};

      setMembershipMetrics(null);
      setDashboardStatistics((prev) => ({
        ...prev,
        totalRegisteredUser: merchants.totalElements,
        totalTerminalIssued: terminalStats.totalTerminals,
        activeTerminals: terminalStats.activeTerminals,
        inactiveTerminals: terminalStats.inactiveTerminals,
        assignedTerminals: terminalStats.assignedTerminals,
        unassignedTerminals: terminalStats.unassignedTerminals,
        totalTerminalRequests: terminalRequestStats.totalRequests,
        pendingTerminalRequests: terminalRequestStats.pendingRequests,
        approvedTerminalRequests: terminalRequestStats.approvedRequests,
        rejectedTerminalRequests: terminalRequestStats.rejectedRequests,
        issuedTerminalRequests: terminalRequestStats.issuedRequests,
        completedTerminalRequests: terminalRequestStats.completedRequests,
        processorTotal: processorInventory.total,
        processorAvailable: processorInventory.totalAvailable,
        processorUsed: processorInventory.totalUsed,
        totalRevenueAcquire: revenue.gross_revenue,
        totalRevenueSettled: revenue.net_revenue,
        totalRevenuePending: terminalRequestStats.pendingRequests,
        totalRevenueRefunded: terminalRequestStats.rejectedRequests,
      }));
    };
    getRevenueMetrics();
  }, []);

  const [showValues, setShowValues] = useState(false);
  const toggle = () => {
    setShowValues(!showValues);
  };
  return (
    <Layout>
      <div className="my-3">
        <h4 className="fs-14 text-default fw-light text-center ">
          WAYAPOS PRODUCT PERFORMANCE METRICS
        </h4>
        <div className="d-flex justify-content-end">
          <div className="show-values-button p-2 d-flex">
            <p className="fs-12 text-dark text-end me-2">
              Show Dashboard Values{" "}
            </p>
            <Switch
              checked={showValues}
              onChange={toggle}
              onColor="#FFDFD2"
              uncheckedIcon={false}
              checkedIcon={false}
              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
              height={15}
              width={30}
              handleDiameter={15}
              className="react-switch"
              id="material-switch"
            />
          </div>
        </div>
      </div>
      <TransactionCount
        showValues={showValues}
        dashboardStatistics={dashboardStatistics}
      />
      <BarChart membershipMetrics={membershipMetrics} />
      <PieCharts />
    </Layout>
  );
};

export default Dashboard;
